import { render } from "./FormatCell.vue?vue&type=template&id=40c04354"
import script from "./FormatCell.vue?vue&type=script&lang=js"
export * from "./FormatCell.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildagent/work/7d7b898a4c764117/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__